import { AccountAsync } from "@/pages/_customer/Account";
import { AccountPaymentAsync } from "@/pages/_customer/AccountPayment";
import { AccountSubscriptionAsync } from "@/pages/_customer/AccountSubscription";
import { ChangePasswordAsync } from "@/pages/_customer/ChangePassword";
import { ChooseAdvisorAsync } from "@/pages/_customer/ChooseAdvisor";
import { CreateProfileAsync } from "@/pages/_customer/CreateProfile";
import { CreateReadingAsync } from "@/pages/_customer/CreateReading";
import { InactiveSubscriptionAsync } from "@/pages/_customer/InactiveSubscription";
import { InviteFriendAsync } from "@/pages/_customer/InviteFriend";
import { LoginAsync } from "@/pages/_customer/Login";
import { MainAsync } from "@/pages/_customer/Main";
import { PsychicDetailsAsync } from "@/pages/_customer/PsychicDetails";
import { PsychicsAsync } from "@/pages/_customer/Psychics";
import { ReadingDetailsAsync } from "@/pages/_customer/ReadingDetails";
import { ResetPasswordAsync } from "@/pages/_customer/ResetPassword";
import { SetNewPasswordAsync } from "@/pages/_customer/SetNewPassword";
import { SignUpAsync } from "@/pages/_customer/SignUp";
import { SupportAsync } from "@/pages/_customer/Support";
import { UserProfileAsync } from "@/pages/_customer/UserProfile";
import { ManageGradesAsync } from "@/pages/_writer/ManageGrades";
import { ManageTagsAsync } from "@/pages/_writer/ManageTags";
import { ManageUserDetailsAsync } from "@/pages/_writer/ManageUserDetails";
import { ManageUsersAsync } from "@/pages/_writer/ManageUsers";
import { ManageWritersAsync } from "@/pages/_writer/ManageWriters";
import { ReadingsAsync } from "@/pages/_writer/Readings";
import { WriterProfileAsync } from "@/pages/_writer/WriterProfile";
import { Forbidden } from "@/pages/Forbidden";
import { NotFound } from "@/pages/NotFound";
import {
  getRouteAccount,
  getRouteAccountChangePassword,
  getRouteAccountPayment,
  getRouteAccountSubscription,
  getRouteChooseAdvisor,
  getRouteCreateProfile,
  getRouteCreateReading,
  getRouteForbidden,
  getRouteHome,
  getRouteInactiveSubscription,
  getRouteInviteFriend,
  getRouteLogin,
  getRouteManageArchivedReadings,
  getRouteManageGrades,
  getRouteManageReadings,
  getRouteManageTags,
  getRouteManageUserDetails,
  getRouteManageUsers,
  getRouteManageWriters,
  getRouteProfile,
  getRoutePsychicDetails,
  getRoutePsychics,
  getRouteReadingDetails,
  getRouteResetPassword,
  getRouteSetNewPassword,
  getRouteSignUp,
  getRouteSupport,
  getRouteWriterProfile,
} from "@/shared/const/routes";
import { UserRole } from "@/shared/const/userRole";

import { AppRouteProps } from "../model/types";

export const configRouter: AppRouteProps[] = [
  {
    path: getRouteSignUp(),
    element: <SignUpAsync />,
    title: "SignUp",
  },
  {
    path: getRouteLogin(),
    element: <LoginAsync />,
    title: "Login",
  },
  {
    path: getRouteResetPassword(),
    element: <ResetPasswordAsync />,
    title: "Request new Password",
  },
  {
    path: getRouteSetNewPassword(),
    element: <SetNewPasswordAsync />,
    title: "Set new Password",
  },
  {
    path: getRouteForbidden(),
    element: <Forbidden />,
    title: "Forbidden",
  },
  {
    path: getRouteHome(),
    element: <MainAsync />,
    title: "My Readings",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteCreateReading(),
    element: <CreateReadingAsync />,
    title: "Request Reading",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteInactiveSubscription(),
    element: <InactiveSubscriptionAsync />,
    title: "Inactive Subscription",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteProfile(),
    element: <UserProfileAsync />,
    title: "My Intuitive Profile",
    roles: [UserRole.Customer],
  },
  {
    path: getRoutePsychicDetails(":id"),
    element: <PsychicDetailsAsync />,
    roles: [UserRole.Customer],
  },
  {
    path: getRouteCreateProfile(),
    element: <CreateProfileAsync />,
    title: "Create Profile",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteSupport(),
    element: <SupportAsync />,
    title: "Contact Us",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteInviteFriend(),
    element: <InviteFriendAsync />,
    title: "Invite a Friend",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteAccount(),
    element: <AccountAsync />,
    title: "Account",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteAccountPayment(),
    element: <AccountPaymentAsync />,
    title: "Payment Methods",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteAccountSubscription(),
    element: <AccountSubscriptionAsync />,
    title: "Subscription",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteChooseAdvisor(),
    element: <ChooseAdvisorAsync />,
    title: "Choose Advisor",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteAccountChangePassword(),
    element: <ChangePasswordAsync />,
    title: "Change Password",
    roles: [UserRole.Customer],
  },
  {
    path: getRouteManageUsers(),
    element: <ManageUsersAsync />,
    title: "Manage Users",
    roles: [UserRole.Writer],
  },
  {
    path: getRouteManageUserDetails(":id"),
    element: <ManageUserDetailsAsync />,
    title: "Manage User Details",
    roles: [UserRole.Writer],
  },
  {
    path: getRouteManageReadings(),
    element: <ReadingsAsync />,
    title: "Readings",
    roles: [UserRole.Writer],
  },
  {
    path: getRouteManageArchivedReadings(),
    element: <ReadingsAsync />,
    roles: [UserRole.Writer],
  },
  {
    path: getRouteWriterProfile(),
    element: <WriterProfileAsync />,
    title: "My Profile",
    roles: [UserRole.Writer],
  },
  {
    path: getRouteManageGrades(),
    element: <ManageGradesAsync />,
    title: "Grades",
    roles: [UserRole.Writer],
  },
  {
    path: getRouteManageTags(),
    element: <ManageTagsAsync />,
    title: "Manage Tags",
    roles: [UserRole.Writer],
  },
  {
    path: getRouteManageWriters(),
    element: <ManageWritersAsync />,
    title: "Manage Writers",
    roles: [UserRole.Writer],
  },
  {
    path: getRouteReadingDetails(":requestId"),
    element: <ReadingDetailsAsync />,
    roles: [UserRole.Customer],
  },
  {
    path: getRoutePsychics(),
    element: <PsychicsAsync />,
    title: "My Psychics",
    roles: [UserRole.Customer],
  },
  {
    path: "*",
    element: <NotFound />,
    title: "Not Found",
  },
];
